<template>
	<div>
      <v-flex xs3>
        <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
      </v-flex>
		<v-data-table loading="true" :headers="headers" :items="tokenList" ref="sortableTable" :search="search" hide-actions disable-initial-sort class="elevation-1">
			<template slot="items" slot-scope="props">
				<tr class="sortableRow" id="rows">
					<td width="40%">{{ props.item.t_description }}</td>
					<td width="40%" class="text-xs-right">{{ props.item.t_token }}</td>
					<td width="10%" class="text-xs-right"><a @click.prevent="fncShowEdit(props.item)"><i class="material-icons">edit</i></a></td>
					<td width="10%" class="text-xs-right"><a @click.prevent="fncTokenDelete(props.item)"><i class="material-icons">delete</i></a></td>
				</tr>
			</template>
		</v-data-table>
	</div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import router from '@/router';

  export default {
	name: 'RoleList',
	intRoleEdit: 0,
    data () {
		return {
			search: '',
            headers: [
              { text: 'Name', value: 'name', width: '40%' },
              { text: 'Token', value: 'description', width: '40%' },
              { text: 'Edit', value: 'edit', width: '10%' },
              { text: 'Delete', value: 'delete', width: '10%' }
            ]
		}
	},
	methods: {
      fncShowEdit(token) {
		  var modalDetails = { title: 'Edit Token - ' + token.t_decription, component: 'modal-token-edit', mstate: true, params:{ token: token } };
		  this.$store.commit({
			  type: 'setModal',
			  details: modalDetails
		  });
		},
        fncTokenDelete(token) {
          var confirmDelete = confirm('Are you sure you would like to remove ' + token.t_description + '?');
          if (confirmDelete === true) {
            this.$store.dispatch({
              type: 'fncTokenDelete',
              token: token
            });
          }
		},
	},
	computed: {
		...mapGetters([
			'userRoles',
			'objRoleEdit',
			'objAuthorize',
      'tokenList',
		])
	},
	beforeMount() {
      this.$store.dispatch('fncPopulateTokens');
      if( this.objAuthorize.email != 'superuser@ndtec.co.za' ) {
        router.replace('/');
      }
	}
}
</script>

<style scoped>
	@import '../shared/assets/css/shared.css'
</style>
